import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useSession } from "../../common/session/SessionContext";
import DeleteDocumentModal from "./DeleteDocumentModal";
import SubmissionModal from "./SubmissionModal";
import { useDocumentSubmissionService } from "./documentSubmissionService";
import {
  ApsAside,
  ApsAsideBody,
  ApsButton,
  ApsButtonAddLarge,
  ApsButtonGroup,
  ApsCard,
  ApsCardBody,
  ApsCardHeader,
  ApsContainer,
  ApsContentContainer,
  ApsPageTitle,
  ApsTypeHeader,
  ApsUploadEntryContainer,
  ApsUploadEntryDocument,
  ApsUserInputContainer
 } from "UserExperience/portal-vnext";

const Upload = ({ openTray }) => {

  const { t } = useTranslation();
  const history = useHistory();
  const { submitDocuments, confirmationNumber, submissionComplete } = useDocumentSubmissionService();
  const { documents, removeDocument, setActiveDocument } = useSession();
  const [isDeleteDocModalVisible, setIsDeleteDocModalVisible] = useState(false);
  const [isSubmissionModalVisible, setIsSubmissionModalVisible] = useState(false);
  const [documentToDelete, setDocumentToDelete] = useState(null);
  const [uploadOption, setUploadOption] = useState(null);
   
  
  const openDocument = (document , isLarge) => {

    if (!document) { return; }

    setActiveDocument(document);

    if (isLarge) {
      openTray();
    }
    else {
      history.push('/add-document');
    }
  }

  const openDeleteDocModal = document => {
    setDocumentToDelete(document);
    setIsDeleteDocModalVisible(true);
  };

  const closeDeleteDocModal = () => {
    setIsDeleteDocModalVisible(false);
  }
  
  const deleteDocument = () => {
    if (documentToDelete) {
      removeDocument(documentToDelete);
      setDocumentToDelete(null);
    }
    closeDeleteDocModal();
  };

  const openSubmissionModal = document => {
    setIsSubmissionModalVisible(true);
  };

  const closeSubmissionModal = () => {
    setIsSubmissionModalVisible(false);
    history.push('/start');
  }

  const dismissSubmissionModal = () => {
    setIsSubmissionModalVisible(false);
  }

  const submit = () => {
    submitDocuments(uploadOption.id, documents); // we do not wait for the result, instead display the modal which watches for changes
    openSubmissionModal();
  };

  useEffect(() => {
    const uploadOptionParam = history.location?.state;
    if (uploadOptionParam) {
      setUploadOption(uploadOptionParam);
    }
    else {
      history.push("/start");
    }
  }, [history])


  if (!uploadOption) {
    return <></>;
  }

  return (
    <>
      <ApsPageTitle titleText={t(uploadOption.displayNameTextId)} />
      <ApsContentContainer containerPadding={true}>
        <ApsAside>
          <ApsAsideBody>
            <ApsTypeHeader headerText={t('uploadScreen.instructionsTitle')} />
            <ApsUserInputContainer text={t(uploadOption.instructionsTextId)} />
            <ApsTypeHeader headerText={t('uploadScreen.documentsYouCanUploadTitle')} />
            <ApsUserInputContainer text={t(uploadOption.documentOptionsTextId)} />
          </ApsAsideBody>
        </ApsAside>

        <ApsContainer containerType="content">

          <ApsCard>

            <ApsCardHeader
              headerTitle={t('uploadScreen.uploadedDocuments')}
              headerTitleAlign="center"
              headerTitleSize="small"
              headerButtonLabel={t('uploadScreen.addDocumentButton')}
              headerButtonClick={openTray}
              className="breakpoint--tablet--is-hidden"
            />

            <ApsCardHeader
              headerTitle={t('uploadScreen.chooseOneOrMore')}
              headerTitleSize="large"
              className="breakpoint--tablet--is-visible--flex"
            />

            <ApsCardBody hasPadding={true}>
              <ApsUploadEntryContainer>
                
                {documents.map((document, index) =>
                <ApsUploadEntryDocument
                  key={index}
                  name={t('uploadScreen.documentIndex') + ' ' + (index + 1)}
                  onClick={() => openDocument(document, false)}
                  onDelete={() => openDeleteDocModal(document)}
                  className="breakpoint--tablet--is-hidden"
                />)}

                {documents.map((document, index) =>
                <ApsUploadEntryDocument
                  key={index}
                  name={t('uploadScreen.documentIndex') + ' ' + (index + 1)}
                  onClick={() => openDocument(document, true)}
                  onDelete={() => openDeleteDocModal(document)}
                  className="breakpoint--tablet--is-visible--flex"
                />)}

                <DeleteDocumentModal
                  visible={isDeleteDocModalVisible}
                  onOk={deleteDocument}
                  onCancel={closeDeleteDocModal}
                />                

              </ApsUploadEntryContainer>

              <ApsButtonAddLarge
                buttonLabel={t('uploadScreen.addDocumentButton')}
                onClick={() => openDocument({}, false)}
                className="breakpoint--tablet--is-hidden"
              />

              <ApsButtonAddLarge
                buttonLabel={t('uploadScreen.addDocumentButton')}
                onClick={() => openDocument({}, true)}
                className="breakpoint--tablet--is-visible--flex"
              />

            </ApsCardBody>
            
          </ApsCard>

          {documents.length > 0 && (
          <>
            <ApsButtonGroup
              groupInset={true}
              groupType="separate"
            >
              <ApsButton
                buttonBlock={true}
                buttonLabel={t('uploadScreen.submitDocumentsButton')}
                buttonShape="pill"
                buttonType="primary"
                onClick={submit}
              />
            </ApsButtonGroup>
            <SubmissionModal
              visible={isSubmissionModalVisible}
              confirmationNumber={confirmationNumber}
              submissionComplete={submissionComplete}
              onOk={closeSubmissionModal}
              onCancel={dismissSubmissionModal}
            />
          </>
          )}
          
        </ApsContainer>

      </ApsContentContainer>
    </>
  );
};

export default Upload;
